import {
	Component,
	OnInit,
	ViewEncapsulation,
	AfterViewInit,
} from "@angular/core";
import { Router } from "@angular/router";
import * as Papi from "@app/papi";
declare let mLayout: any;
@Component({
	selector: "app-aside-nav",
	templateUrl: "./aside-nav.component.html",
	encapsulation: ViewEncapsulation.None,
	standalone: false
})
export class AsideNavComponent implements OnInit, AfterViewInit {
	isOpen = false;
	isChildRouteActive = false;
	constructor(public papi: Papi.Service, private router: Router) {}
	ngOnInit() {
		this.papi.authorize("arcadmin").subscribe((result: boolean) => {
			// force initialization of actions cache
		});
	}
	toggleMenu(event: Event): void {
		event.stopPropagation(); // Prevents event bubbling
		this.isOpen = !this.isOpen; // Toggle state
	}
	ngAfterViewInit() {
		mLayout.initAside();
	}
}
